<input 
  class="input is-small" 
  [type]="type" placeholder="YYYY-MM-DD" 
  [formControl]="datePicker" [min]="getMinDateTime()" max="2099-01-31" (change)="onDateChange($event)"
  [attr.lang]="currentLang"
   />
<div *ngIf="!isValid" class="invalid-msg">
  The currently entered date is invalid.<br/>
  Use the format YYYY-MM-DD
</div>